<section
  class="project-page"
  [style.min-height.px]="pageHeight()"
  [style.--project-bg]="project().backgroundColor"
  [style.--project-fg]="project().textColor"
>
  <app-header [showSideLinks]="true" />

  <main
    class="project-page__scroll"
    [style.height.px]="pageHeight()"
  >
    <div
      #stage
      class="project-page__stage"
    >
      <section
        class="project-slide"
        *ngFor="let section of sections(); let i = index"
        [style.clip-path]="getSectionClipPath(i)"
        [style.transform]="getSectionTransform(i)"
        [style.z-index]="getSectionZIndex(i)"
      >
        <img
          class="project-slide__image"
          [style.transform]="getSectionContentTransform(i)"
          [src]="section.image"
          [alt]="section.alt || project().title"
        >
      </section>

      <section
        class="project-slide project-slide--info"
        [style.clip-path]="getInfoClipPath()"
        [style.transform]="getSectionTransform(sections().length)"
        [style.z-index]="getInfoZIndex()"
      >
        <div
          class="project-page__info-inner"
          [style.transform]="getSectionContentTransform(sections().length)"
        >
          <p class="project-page__description">
            {{ projectInfo().description }}
          </p>

          <dl class="project-page__meta">
            <div class="project-page__meta-row">
              <dt>Client</dt>
              <dd>{{ projectInfo().client }}</dd>
            </div>

            <div class="project-page__meta-row">
              <dt>Service</dt>
              <dd>{{ projectInfo().service }}</dd>
            </div>

            <div class="project-page__meta-row">
              <dt>Year</dt>
              <dd>{{ projectInfo().year }}</dd>
            </div>

            <div class="project-page__meta-row project-page__meta-row--site">
              <dt>
                <a
                  class="project-page__site-label"
                  [href]="siteHref()"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span class="project-page__site-arrow">→</span>
                  <span>Site</span>
                </a>
              </dt>

              <dd>
                <a
                  class="project-page__site-url"
                  [href]="siteHref()"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ projectInfo().site }}
                </a>
              </dd>
            </div>
          </dl>
        </div>
      </section>
    </div>
  </main>
</section>
